"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadLanguageTagMapper = exports.cadClickLanguageTags = void 0;
const LanguageTagMatcher_1 = require("./LanguageTagMatcher");
/**
 * IETF language tags supported by CADClick.
 * The IETF language tags are sorted by priority.
 * If only the language subtag of the IETF language tag is known,
 * the first matching IETF language tag should be taken.
 * For 'en' this is 'en-GB' instead of 'en-US'.
 */
exports.cadClickLanguageTags = [
    'en-GB',
    'en-US',
    'en-AU',
    'en-CA',
    'en-IE',
    'en-NZ',
    //
    'de-DE',
    'de-CH',
    'de-AT',
    //
    'fr-FR',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    //
    'it-IT',
    'it-CH',
    //
    'es-ES',
    'es-AR',
    'es-MX',
    //
    'el-GR',
    //
    'hu-HU',
    //
    'pt-BR',
    'pt-PT',
    //
    'tr-TR',
    //
    'sv-SE',
    //
    'ja-JP',
    //
    'zh-CN',
    'zh-TW',
    //
    'cs-CZ',
    //
    'da-DK',
    //
    'nl-NL',
    'nl-BE',
    //
    'fi-FI',
    //
    'is-IS',
    //
    'ko-KR',
    //
    'nb-NO',
    //
    'nn-NO',
    //
    'pl-PL',
    //
    'ru-RU',
    //
    'sr-SP-Latn',
    //
    'sk-SK',
    //
    'uk-UA',
    //
    'ro-RO', // Romanian
];
/**
 * The mapper is used to find the best matching CADClick IETF language tag for the given IETF language tag.
 */
class CadLanguageTagMapper {
    /**
     * Constructor
     *
     * @param defaultCadClickLanguageTag The default CADClick IETF language tag.
     */
    constructor(defaultCadClickLanguageTag) {
        this.defaultCadClickLanguageTag = defaultCadClickLanguageTag;
    }
    /**
     * Finds the best matching CADClick IETF language tag for the given IETF language tag.
     * The returned CADClick IETF language tag is from the list of CADClick IETF language tags.
     * If no match is found, then the default CADClick IETF language tag is returned.
     *
     * @param languageTag The IETF language tag that should be matched to a CADClick IETF language tag.
     */
    mapLanguageTag(languageTag) {
        const matcher = new LanguageTagMatcher_1.LanguageTagMatcher(exports.cadClickLanguageTags, this.defaultCadClickLanguageTag);
        return matcher.findBestMatch(languageTag);
    }
}
exports.CadLanguageTagMapper = CadLanguageTagMapper;
//# sourceMappingURL=CadLanguageTagMapper.js.map